'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Numbers = (_temp = _class = function (_SvgIcon) {
    _inherits(Numbers, _SvgIcon);

    function Numbers() {
        _classCallCheck(this, Numbers);

        return _possibleConstructorReturn(this, (Numbers.__proto__ || Object.getPrototypeOf(Numbers)).apply(this, arguments));
    }

    _createClass(Numbers, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement(
                        'defs',
                        null,
                        _react2['default'].createElement('path', { id: 'a', d: 'M0 .4h32.056v44.5998H0z' }),
                        _react2['default'].createElement('path', { id: 'c', d: 'M.0005.4H32.056v44.5998H.0005z' }),
                        _react2['default'].createElement('path', { id: 'e', d: 'M0 45.6003h32.056v-44.6H0z' })
                    ),
                    _react2['default'].createElement(
                        'g',
                        { transform: 'translate(0 -.5)', fill: 'none', 'fill-rule': 'evenodd' },
                        _react2['default'].createElement(
                            'g',
                            { transform: 'translate(0 .6003)' },
                            _react2['default'].createElement(
                                'mask',
                                { id: 'b', fill: '#fff' },
                                _react2['default'].createElement('use', { xlinkHref: '#a' })
                            ),
                            _react2['default'].createElement('path', { d: 'M32.0569 40.8188c0 2.309-1.872 4.181-4.182 4.181H4.1809c-2.309 0-4.181-1.872-4.181-4.181V3.8838c0-2.309 1.175-3.484 3.485-3.484h25.088c2.308 0 3.484 1.175 3.484 3.484v36.935z', fill: '#EBEBEB', mask: 'url(#b)' })
                        ),
                        _react2['default'].createElement(
                            'g',
                            { transform: 'translate(0 .6003)' },
                            _react2['default'].createElement(
                                'mask',
                                { id: 'd', fill: '#fff' },
                                _react2['default'].createElement('use', { xlinkHref: '#c' })
                            ),
                            _react2['default'].createElement('path', { d: 'M28.5725.3998h-.937L.0005 28.0358v12.783c0 2.309 1.872 4.181 4.18 4.181h23.695c2.309 0 4.181-1.872 4.181-4.181V3.8838c0-2.309-1.175-3.484-3.484-3.484', fill: '#E3E3E3', mask: 'url(#d)' })
                        ),
                        _react2['default'].createElement(
                            'mask',
                            { id: 'f', fill: '#fff' },
                            _react2['default'].createElement('use', { xlinkHref: '#e' })
                        ),
                        _react2['default'].createElement('path', { fill: '#5E6174', mask: 'url(#f)', d: 'M2.788 15.0113h26.481V4.9963H2.788z' }),
                        _react2['default'].createElement('path', { d: 'M9.1741 24.5592h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72M18.6487 24.5592h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#CCC', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M28.1233 24.5592h-5.724c-.396 0-.719-.324-.719-.72v-5.377c0-.396.323-.72.719-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#696C82', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M9.1741 33.381h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72M18.6487 33.381h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#CCC', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M28.1233 33.381h-5.724c-.396 0-.719-.324-.719-.72v-5.377c0-.396.323-.72.719-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#696C82', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M9.1741 42.2023h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#CCC', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M28.1233 35.3849h-15.198c-.397 0-.721.324-.721.72v5.377c0 .396.324.72.721.72H28.1233c.396 0 .72-.324.72-.72v-5.377c0-.396-.324-.72-.72-.72', fill: '#FB6566', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { fill: '#80839E', mask: 'url(#f)', d: 'M2.7874 4.9967v10.015h14.338l10.015-10.015z' }),
                        _react2['default'].createElement('path', { d: 'M11.343 10.1183c0-1.234-.363-1.836-.957-1.836s-.961.606-.961 1.832c0 1.234.367 1.856.961 1.856.598 0 .957-.622.957-1.852m-3.375 0c0-1.852.937-2.953 2.418-2.953 1.484 0 2.414 1.098 2.414 2.949 0 1.84-.922 2.973-2.414 2.973s-2.418-1.125-2.418-2.969M14.8743 8.5675h-.027l-1.41.945v-1.226l1.433-.977h1.43v5.637h-1.426zM19.5696 7.1691c1.293 0 2.133.695 2.133 1.68 0 .726-.367 1.136-1.281 1.965l-1.102 1.003v.028h2.453v1.101h-4.297v-.976l2-1.801c.696-.625.84-.879.84-1.227 0-.406-.309-.695-.746-.695-.492 0-.863.328-.863.824h-1.313c0-1.14.879-1.902 2.176-1.902M23.929 9.5675h.605c.551 0 .887-.27.887-.68 0-.41-.297-.652-.777-.652-.496 0-.824.266-.856.691h-1.3c.05-1.078.91-1.757 2.156-1.757 1.222 0 2.108.558 2.108 1.515 0 .723-.523 1.184-1.167 1.313v.027c.851.086 1.39.566 1.39 1.328 0 1.055-.91 1.735-2.323 1.735-1.328 0-2.243-.707-2.297-1.79h1.367c.035.383.375.665.93.665.511 0 .867-.282.867-.696 0-.469-.352-.726-.977-.726h-.613v-.973z', fill: '#FFF', mask: 'url(#f)' })
                    )
                );
            }

            return render;
        }()
    }]);

    return Numbers;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '-6 0 33 46',
    xlinkHref: 'http://www.w3.org/1999/xlink'
}, _temp);
exports['default'] = Numbers;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Numbers.js
// module id = 1389
// module chunks = 32